import { render, staticRenderFns } from "./ChangePriorityModal.vue?vue&type=template&id=f84327fc&scoped=true&"
import script from "./ChangePriorityModal.vue?vue&type=script&lang=js&"
export * from "./ChangePriorityModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangePriorityModal.vue?vue&type=style&index=0&id=f84327fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84327fc",
  null
  
)

export default component.exports